import { render, staticRenderFns } from "./AdminEdit.vue?vue&type=template&id=b105e102&scoped=true&"
import script from "./AdminEdit.vue?vue&type=script&lang=js&"
export * from "./AdminEdit.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=b105e102&prod&scoped=true&lang=css&"
import style1 from "./AdminEdit.vue?vue&type=style&index=1&id=b105e102&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b105e102",
  null
  
)

export default component.exports